import { useContext, useRef } from 'react'

import { OptimizelyContext } from '@optimizely/react-sdk'

const APPLIED_DISCOUNT_FLAG = 'winback_ofx_webclient_discounts_in_menu'

/**
 * Whether the applied discount badge may be shown. The flag is decided only when there is a
 * discount to show, and the decision is kept for the page's lifetime so neither re-renders nor
 * `hasBanner` flipping (for example while the page loader covers the header) re-emit the exposure.
 */
export const useShowAppliedDiscountOnOrderConfirmation = (hasBanner: boolean): boolean => {
  const { optimizely } = useContext(OptimizelyContext)
  const decision = useRef<{ client: unknown; enabled: boolean }>()

  if (optimizely && hasBanner && decision.current?.client !== optimizely) {
    decision.current = {
      client: optimizely,
      enabled: optimizely.decide(APPLIED_DISCOUNT_FLAG).enabled,
    }
  }

  return hasBanner && decision.current?.enabled === true
}
